import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2'; 
import { useNavigate } from "react-router-dom";
function RegistrationForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobileno: '',
    dob: '',
    address: '',
    pass:'',
    cpass:''
  });
  const [isLoading, setIsLoading] = useState(false);
 
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const [errors, setErrors] = useState({});

    const validateForm = () => {
      const newErrors = {};
      
      // Name validation
      if (!formData.name.trim()) {
        newErrors.name = 'Name is required';
      }
  
      // Mobile validation
      if (!formData.mobileno.trim()) {
        newErrors.mobileno = 'Mobile number is required';
      } else if (!/^[0-9]{10}$/.test(formData.mobileno)) {
        newErrors.mobileno = 'Enter valid 10-digit mobile number';
      }
  
      // Email validation
      if (!formData.email.trim()) {
        newErrors.email = 'Email is required';
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = 'Enter valid email address';
      }
  
      // DOB validation
      if (!formData.dob) {
        newErrors.dob = 'Date of Birth is required';
      }
  
      // Address validation
      if (!formData.address.trim()) {
        newErrors.address = 'Address is required';
      }
        // Password validation
        if (!formData.pass.trim()) {
          newErrors.pass = 'Password is required';
        }
         // Confirm Password  validation
         if (!formData.cpass.trim()) {
          newErrors.cpass = 'Confirm Password is required';
        }
  
      // Password validation
      if (!formData.pass.trim()) {
        newErrors.pass = 'Password is required';
      } else if (formData.pass.length < 6) {
        newErrors.pass = 'Password must be at least 6 characters';
      }

      // Confirm Password validation
      if (!formData.cpass.trim()) {
        newErrors.cpass = 'Confirm Password is required';
      } else if (formData.pass !== formData.cpass) {
        newErrors.cpass = 'Passwords do not match';
      }
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      //alert("Submted1")
      if (validateForm()) {
        setIsLoading(true); 
        try {
          const response = await axios.post('/api/user.php', formData, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer vetri_kuralattam_XKokBfNWv6FIYuTMg5sLPjhJ',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'POST',
              'Access-Control-Allow-Headers': 'Content-Type, Authorization'
            }
          });
  
          console.log("response :",response)
        
          if (response.data.message) {
            Swal.fire({
              title: "Good job!",
              text: "Your Registration successful!",
              icon: "success"
            });

            Swal.fire({
              title: "Good job!",
              text: "Your Registration successful!",
              icon: "success",
            }).then((result) => {
              if (result.isConfirmed) {
                navigate("/");
              }
            });
            // Reset form
            setFormData({
              name: '',
              email: '',
              mobileno: '',
              dob: '',
              address: '',
            });
            setErrors({});
          } else {
           // alert('Registration successful!');
            alert(response.data.message || 'Registration failed. Please try again.');
          }
        } catch (error) {
          console.error('Registration failed:', error);
          //alert('Server error. Please try again later.');
          Swal.fire({
            title: "Error",
            text: error.response.data.error,
            icon: "error"
          });
        }finally {
          setIsLoading(false); // Stop loading
        }
      }
    };
  
    return (
      <div className="bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 p-8 rounded-lg shadow-lg w-full max-w-md mx-auto">
        <div className="flex items-center mb-4">
          <button
            onClick={() => navigate('/')}
            className="text-white hover:text-gray-200 focus:outline-none mr-4"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
          </button>
          <h2 className="text-2xl font-bold text-white text-center flex-grow">Register</h2>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-white">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={`w-full p-2 rounded border ${errors.name ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-purple-600 text-black bg-white`}
            />
            {errors.name && <p className="text-yellow-200 text-sm mt-1">{errors.name}</p>}
          </div>
          <div>
            <label className="block text-white">Mobile No</label>
            <input
              type="text"
              name="mobileno"
              value={formData.mobileno}
              onChange={handleChange}
              className={`w-full p-2 rounded border ${errors.mobileno ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-purple-600 text-black bg-white`}
            />
            {errors.mobileno && <p className="text-yellow-200 text-sm mt-1">{errors.mobileno}</p>}
          </div>
          <div>
            <label className="block text-white">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`w-full p-2 rounded border ${errors.email ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-purple-600 text-black bg-white`}
            />
            {errors.email && <p className="text-yellow-200 text-sm mt-1">{errors.email}</p>}
          </div>
          <div>
            <label className="block text-white">Date of Birth</label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              className={`w-full p-2 rounded border ${errors.dob ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-purple-600 text-black bg-white`}
            />
            {errors.dob && <p className="text-yellow-200 text-sm mt-1">{errors.dob}</p>}
          </div>
          <div>
            <label className="block text-white">Address</label>
            <textarea
              name="address"
              rows="2"
              value={formData.address}
              onChange={handleChange}
              className={`w-full p-2 rounded border ${errors.address ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-purple-600 text-black bg-white resize-none`}
            />
            {errors.address && <p className="text-yellow-200 text-sm mt-1">{errors.address}</p>}
          </div>
          <div>
            <label className="block text-white">Password</label>
            <input
              type="password"
              name="pass"
              value={formData.pass}
              onChange={handleChange}
              className={`w-full p-2 rounded border ${errors.dob ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-purple-600 text-black bg-white`}
            />
            {errors.pass && <p className="text-yellow-200 text-sm mt-1">{errors.pass}</p>}
          </div>
          <div>
            <label className="block text-white">Confirm Password</label>
            <input
              type="password"
              name="cpass"
              value={formData.cpass}
              onChange={handleChange}
              className={`w-full p-2 rounded border ${errors.dob ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-purple-600 text-black bg-white`}
            />
            {errors.cpass && <p className="text-yellow-200 text-sm mt-1">{errors.cpass}</p>}
          </div>
          <button
    type="submit"
    disabled={isLoading}
    className="w-full px-6 py-3 text-base md:text-lg font-semibold rounded-xl bg-yellow-400 hover:bg-yellow-500 text-gray-900 shadow-lg transform hover:scale-105 transition-transform duration-200 flex items-center justify-center"
  >
    {isLoading ? (
      <>
        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Registering...
      </>
    ) : (
      'Register'
    )}
  </button>
      </form>
    </div>
  );
}

export default RegistrationForm;
